import { FlashMessageContext } from './context';

type Props = {
  scope?: string;
  children?: React.ReactNode;
};

export const FlashMessageScope = ({ scope, children }: Props): JSX.Element => {
  return <FlashMessageContext.Provider value={scope}>{children}</FlashMessageContext.Provider>;
};
